import {
	IGetModifierGroupsInfo,
	IGetModifierGroupInfoV2,
	IGetModifierGroupsShort,
	IGetModifierGroupsShortResponse,
	IGetModifierGroupPaginatedInfo,
	ICreateModifierGroups,
	ICreateModifierGroupsV2,
	IUpdateModifierGroups,
	IUpdateModifierGroupsV2,
	IGetPaginatedModifierGroups,
	IGetPaginatedModifierGroupsV2,
	IModifierGroups,
	IModifierGroupsV2,
	IGetModifierGroupsTemplateInfoArgs,
	IGetModifierGroupsTemplateInfo,
	IUpdateModifierGroupsTemplateInfo,
	IGetModifierGroupsByProductIdAndRestaurantIdArguments,
	IGetModifierGroupsByProductIdAndRestaurantId,
	IGetAllModifierGroupsFromCustomerByProductIdAndRestaurantId,
	IGetModGroupRestaurantProperties,
	IGetModGroupRestaurantPropertiesArguments,
	IGetModifierTemplatesResponse,
	IGetAvailableModifiersResponse,
	IGetModifiersForAssignArguments,
	IGetModifiersForAssignResponse,
	IUpdateModGroupRestaurantProperties,
	IUpdateRestaurantPropertiesAsPatchForModGroup,
	IUpdateModGroupProductsInclusive,
} from 'types';
import { AxiosResponse } from 'axios';
import { request } from '../index';

// Menu v1
const serviceGetModifierGroupsInfo = (modifierGroupID: string): Promise<IGetModifierGroupsInfo> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/ModifierGroups/${modifierGroupID}` });
};
// Menu v1
// Menu v2
const serviceGetModifierGroupInfoV2 = (modifierGroupID: string): Promise<AxiosResponse<IGetModifierGroupInfoV2>> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/v2/mod-groups/${modifierGroupID}` });
};
// Menu v2
const serviceGetModifierGroupsShort = (args: IGetModifierGroupsShort): Promise<IGetModifierGroupsShortResponse> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/ModifierGroups/short`, data: args });
};

const serviceGetModifierGroupPaginatedInfo = (modifierGroupID: string): Promise<IGetModifierGroupPaginatedInfo> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/ModifierGroups/${modifierGroupID}/full-info` });
};

// Menu v1
const serviceCreateModifierGroups = (data: ICreateModifierGroups): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/ModifierGroups`, data });
};
// Menu v1
// Menu v2
const serviceCreateModifierGroupsV2 = (data: ICreateModifierGroupsV2): Promise<AxiosResponse<{ id: string }>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/v2/mod-groups`, data });
};
// Menu v2

// Menu v1
const serviceUpdateModifierGroups = (data: IUpdateModifierGroups): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/ModifierGroups/${data.id}`, data });
};
// Menu v1
// Menu v2
const serviceUpdateModifierGroupsV2 = (data: IUpdateModifierGroupsV2): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/v2/mod-groups/${data.id}`, data });
};
// Menu v2

// Menu v1
const serviceGetPaginatedModifierGroups = (
	args: IGetPaginatedModifierGroups,
): Promise<AxiosResponse<IModifierGroups>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/ModifierGroups/filtered`, data: args });
};
// Menu v1
// Menu v2
const serviceGetPaginatedModifierGroupsV2 = (
	args: IGetPaginatedModifierGroupsV2,
): Promise<AxiosResponse<IModifierGroupsV2>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/v2/mod-groups:search`, data: args });
};
// Menu v2

const serviceDeleteModifierGroups = (modifierGroupID: string): Promise<AxiosResponse<void>> => {
	return request({
		typeOfRequest: 'deleteWithTokenAndWithParameterInUrlLine',
		url: `/api/ModifierGroups/${modifierGroupID}`,
	});
};

// Menu v2
const serviceDeleteModifierGroupsV2 = (modifierGroupID: string): Promise<AxiosResponse<void>> => {
	return request({
		typeOfRequest: 'deleteWithTokenAndWithParameterInUrlLine',
		url: `/api/v2/mod-groups/${modifierGroupID}`,
	});
};
// Menu v2

const serviceGetModifierGroupsTemplateInfo = (
	args: IGetModifierGroupsTemplateInfoArgs,
): Promise<AxiosResponse<IGetModifierGroupsTemplateInfo>> => {
	return request({
		typeOfRequest: 'getWithToken',
		url: `/api/v2/products/${args.productId}/mod-group-templates?type=${args.type}`,
	});
};

const serviceUpdateModifierGroupsTemplateInfo = (
	data: IUpdateModifierGroupsTemplateInfo,
): Promise<AxiosResponse<void>> => {
	return request({
		typeOfRequest: 'putWithToken',
		url: `/api/v2/products/${data.productId}/mod-group-templates`,
		data,
	});
};

const serviceGetModifierGroupsByProductIdAndRestaurantId = (
	args: IGetModifierGroupsByProductIdAndRestaurantIdArguments,
): Promise<IGetModifierGroupsByProductIdAndRestaurantId> => {
	return request({
		typeOfRequest: 'getWithToken',
		url: `/api/v2/products/${args.productId}/mod-groups?restaurantId=${args.restaurantId}&type=${args.type}`,
	});
};

const serviceGetAllModifierGroupsFromCustomerByProductIdAndRestaurantId = (
	args: IGetModifierGroupsByProductIdAndRestaurantIdArguments,
): Promise<IGetAllModifierGroupsFromCustomerByProductIdAndRestaurantId> => {
	return request({
		typeOfRequest: 'getWithToken',
		url: `/api/v2/products/${args.productId}/mod-groups:assign?restaurantId=${args.restaurantId}&type=${args.type}`,
	});
};

const serviceGetModifierGroupsShortByCustomerId = (customerId: string): Promise<IGetModifierGroupsShortResponse> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/v2/customers/${customerId}/mod-groups` });
};

const serviceGetModifierGroupsShortByRestaurantId = (
	restaurantId: string,
): Promise<IGetModifierGroupsShortResponse> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/v2/restaurants/${restaurantId}/mod-groups` });
};

const serviceGetModGroupRestaurantProperties = (
	args: IGetModGroupRestaurantPropertiesArguments,
): Promise<AxiosResponse<IGetModGroupRestaurantProperties>> => {
	return request({
		typeOfRequest: 'getWithToken',
		url: `/api/v2/restaurants/${args.restaurantId}/restaurant-mod-groups/${args.modGroupId}`,
	});
};

const serviceUpdateRestaurantsInModGroup = (data: {
	modifierGroupId: string;
	restaurantIds: string[];
}): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/v2/mod-groups:update-restaurants`, data });
};

const serviceGetModifierTemplates = (
	modifierGroupId: string,
): Promise<AxiosResponse<IGetModifierTemplatesResponse>> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/v2/mod-groups/${modifierGroupId}/modifier-templates` });
};

const serviceGetAvailableModifiers = (customerId: string): Promise<AxiosResponse<IGetAvailableModifiersResponse>> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/v2/customers/${customerId}/products` });
};

const serviceUpdateModifierTemplates = (data: {
	modifierGroupId: string;
	modifierIds: string[];
}): Promise<AxiosResponse<void>> => {
	return request({
		typeOfRequest: 'putWithToken',
		url: `/api/v2/mod-groups/${data.modifierGroupId}/modifier-templates`,
		data,
	});
};

const serviceGetModifiersForAssign = (
	args: IGetModifiersForAssignArguments,
): Promise<AxiosResponse<IGetModifiersForAssignResponse['data']>> => {
	return request({
		typeOfRequest: 'getWithToken',
		url: `/api/v2/mod-groups/${args.modGroupId}/modifiers:assign?restaurantId=${args.restaurantId}`,
	});
};

const serviceUpdateModGroupRestaurantProperties = (
	data: IUpdateModGroupRestaurantProperties,
): Promise<AxiosResponse<void>> => {
	return request({
		typeOfRequest: 'putWithToken',
		url: `/api/v2/restaurants/${data.restaurantId}/restaurant-mod-groups/${data.modifierGroupId}`,
		data,
	});
};

const serviceUpdateModGroupRestaurantPropertiesAsPatch = (
	data: IUpdateRestaurantPropertiesAsPatchForModGroup,
): Promise<AxiosResponse<void>> => {
	return request({
		typeOfRequest: 'putWithToken',
		url: `/api/v2/restaurant-mod-groups/${data.modifierGroupId}`,
		data,
	});
};

const serviceUpdateModGroupProductsInclusive = (
	data: IUpdateModGroupProductsInclusive,
): Promise<AxiosResponse<void>> => {
	return request({
		typeOfRequest: 'putWithToken',
		url: `/api/v2/restaurants/${data.restaurantId}/mod-groups/${data.modifierGroupId}/products:update-inclusive`,
		data,
	});
};

export {
	serviceGetModifierGroupsInfo,
	serviceGetModifierGroupInfoV2,
	serviceGetModifierGroupsShort,
	serviceGetModifierGroupPaginatedInfo,
	serviceCreateModifierGroups,
	serviceCreateModifierGroupsV2,
	serviceUpdateModifierGroups,
	serviceUpdateModifierGroupsV2,
	serviceGetPaginatedModifierGroups,
	serviceGetPaginatedModifierGroupsV2,
	serviceDeleteModifierGroups,
	serviceDeleteModifierGroupsV2,
	serviceGetModifierGroupsTemplateInfo,
	serviceUpdateModifierGroupsTemplateInfo,
	serviceGetModifierGroupsByProductIdAndRestaurantId,
	serviceGetAllModifierGroupsFromCustomerByProductIdAndRestaurantId,
	serviceGetModifierGroupsShortByCustomerId,
	serviceGetModifierGroupsShortByRestaurantId,
	serviceGetModGroupRestaurantProperties,
	serviceUpdateRestaurantsInModGroup,
	serviceGetModifierTemplates,
	serviceGetAvailableModifiers,
	serviceUpdateModifierTemplates,
	serviceGetModifiersForAssign,
	serviceUpdateModGroupRestaurantProperties,
	serviceUpdateModGroupRestaurantPropertiesAsPatch,
	serviceUpdateModGroupProductsInclusive,
};
